import React from "react";
// import { loginApi } from "../api/api_login";
import { toast } from "react-toastify";

var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();

function userReducer(state, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, isAuthenticated: true };
    case "SIGN_OUT_SUCCESS":
      return { ...state, isAuthenticated: false };
    default: {
      // throw new Error(`Unhandled action type: ${action.type}`);
      toast.error("کاربری با این مشخصات پیدا نشد!");
      return { ...state, isAuthenticated: false };
    }
  }
}

function UserProvider({ children }) {
  var [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: !!localStorage.getItem("id_token"),
  });

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  var context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error("useUserState must be used within a UserProvider");
  }
  return context;
}

function useUserDispatch() {
  var context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error("useUserDispatch must be used within a UserProvider");
  }
  return context;
}

export { UserProvider, useUserState, useUserDispatch, loginUser, signOut };

// ###########################################################

function loginUser(dispatch, login, password, history, setIsLoading) {
  setIsLoading(true);
  // const user = {
  //   username: login,
  //   password: password.toString(),
  //   platform: "web",
  // };
  // loginApi(user, (isOk, data) => {
  //   if (isOk) {
  //     setTimeout(() => {
  //       localStorage.setItem('id_token', data.token);
  //       setIsLoading(false);
  //       dispatch({ type: "LOGIN_SUCCESS" });
  //       history.push("/app/dashboard");
  //     }, 2000);
  //   } else {
  //     dispatch({ type: "LOGIN_FAILURE" });
  //     setIsLoading(false);
  //   }
  // });
  if (login === "admin" && password.toString() === "123") {
    setTimeout(() => {
      // localStorage.setItem('id_token', data.token);
      localStorage.setItem("id_token", "data.token");
      setIsLoading(false);
      dispatch({ type: "LOGIN_SUCCESS" });
      history.push("/app/main");
    }, 2000);
  } else {
    dispatch({ type: "LOGIN_FAILURE" });
    setIsLoading(false);
  }
}

function signOut(dispatch, history) {
  localStorage.removeItem("id_token");
  dispatch({ type: "SIGN_OUT_SUCCESS" });
  history.push("/login");
}
